<template>
  <div class="page">
    <!-- 预约信息 -->
    <oabCard :data="detailData.listData"></oabCard>
    <load :isShow="loading" />
    <!-- 取消弹窗 -->
    <van-dialog
      v-model:show="isShowDialog"
      title=""
      :before-close="beforeCloseDialog"
      show-cancel-button
      :confirm-button-text="dialogConfig.confirmButtonText"
      confirm-button-color="#3088c5"
    >
      <div class="dialogContent">
        <h3 class="title" v-if="dialogConfig.title">
          {{ dialogConfig.title }}
        </h3>
        <div v-html="dialogConfig.content"></div>
      </div>
    </van-dialog>
    <!-- 底部按钮 -->
    <div class="bottomWrap" v-if="detailData?.btnData?.length > 0">
      <BottomBtn :data="detailData.btnData" @click="clickBtn" align="center"></BottomBtn>
    </div>
  </div>
</template>
<script>
import { reactive, toRefs, onMounted, nextTick } from 'vue'
import { useRoute } from 'vue-router'
import load from '@/components/oab/fullLoad.vue'
import oabCard from '@/components/oab/detailCard.vue'
import BottomBtn from '@/components/order/BottomBtn'
import { getOrderDetail, cancleOab } from '@/api/oab'
import { reorganizeDetailData, calculateTimeout } from '@/util/oab'
import { btnCallBack } from '@/util/order/handle'
import { showToast } from '@/util/couponCollection'

export default {
  components: {
    load,
    BottomBtn,
    oabCard
  },
  setup() {
    const route = useRoute()
    let { oabId = '' } = route.query
    const state = reactive({
      detailData: {
        listData: [
          { id: 'base', text: '订单基本信息', list: [] },
          { id: 'dealer', text: '经销商信息', list: [] }
        ]
      },
      loading: false,
      isShowDialog: false,
      dialogConfig: {
        // title: '确认取消',
        content: '是否确认取消订单？',
        confirmButtonText: '确认取消',
        cancelButtonText: '暂不取消'
      }
    })
    // 获取预约列表数据
    const getDetailData = async isShowLoad => {
      try {
        isShowLoad && (state.loading = true)
        let data = await getOrderDetail({ reservationId: oabId })
        let detailData = reorganizeDetailData(data)
        state.detailData = detailData
        state.loading = false
      } catch (e) {
        showToast(e.message, '获取预约列表数据失败')
        state.detailData = {
          listData: [
            { id: 'base', text: '订单基本信息', list: [] },
            { id: 'dealer', text: '经销商信息', list: [] }
          ]
        }
        state.loading = false
      }
    }
    onMounted(async () => {
      getDetailData(true)
    })
    // 点击按钮
    const clickBtn = v => {
      let { id, _data } = v
      console.log('clickBtn-->', id, _data)
      if (id === 'cancel') {
        let res = calculateTimeout(_data.cancelTime)
        if (!res) {
          getDetailData()
        } else {
          const param = { reservationId: _data.id }
          state.dialogConfig = Object.assign(state.dialogConfig, { subParam: { v, param }, cb: cancleOab })
          state.isShowDialog = true
        }
      }
    }
    //关闭弹窗
    const beforeCloseDialog = async action => {
      if (action === 'confirm') {
        try {
          const {
            subParam: { v, param },
            cb
          } = state.dialogConfig
          // console.log(state.dialogConfig.subParam,param)
          cb && (await cb(param))
          v.fn && (await btnCallBack(v, param))
          nextTick(async () => {
            await getDetailData()
          })
          return true
        } catch (e) {
          showToast(e.message, '操作失败')
        }
      }
      if (action === 'cancel') {
        state.dialogConfig.subParam = {}
        return true
      }
    }
    return {
      ...toRefs(state),
      clickBtn,
      beforeCloseDialog
    }
  }
}
</script>
<style lang="scss" scoped>
.page {
  padding-top: 20px;
  padding-left: 20px;
  padding-right: 20px;
  box-sizing: border-box;
  background-color: #fff;
  padding-bottom: calc(80px + constant(safe-area-inset-bottom));
  padding-bottom: calc(80px + env(safe-area-inset-bottom));
  :deep(.van-popup.van-dialog button) {
    background: #fff;
    color: #666;
  }
  :deep(.dialogContent) {
    padding: 38px 10px;
    color: #333;
    font-size: 16px;
    font-weight: 400;
  }
}
.bottomWrap {
  position: fixed;
  bottom: 10px;
  left: 0;
  right: 0;
  background-color: #fff;
  padding-top: 16px;
  padding-left: 20px;
  padding-right: 20px;
  padding-bottom: calc(30px + constant(safe-area-inset-bottom));
  padding-bottom: calc(30px + env(safe-area-inset-bottom));
}
</style>
